/* eslint-disable max-len */
import React, {
  useEffect, useMemo, useRef, useState,
} from 'react';
import moment from 'moment';
import { Form } from 'antd';
import useTranslation from '../../../hooks/translation/useTranslation';
import ScheduleList from './components/ScheduleList';
import { getSchedules } from '../../../../services/customer/scheduleServices';
import './schedule.scss';
import ScheduleForm from '../../forms/scheduleForm/ScheduleForm';
import { useAuth } from '../../../contexts/userContext/userContext';

const routeTypes = {
  route_type_district: 'district_trains',
  route_type_international: 'international_trains',
  route_type_local: 'local_trains',
  district: 'district_trains',
  international: 'international_trains',
  local: 'local_trains',
};

// Sorting function to compare departure times
function compareDepartureTime(a, b) {
  const departureTimeA = a.endDate;
  const departureTimeB = b.endDate;

  if (departureTimeA < departureTimeB) {
    return -1;
  }
  if (departureTimeA > departureTimeB) {
    return 1;
  }
  return 0;
}

function Schedule() {
  const allSchedules = useRef(null);
  const { trans, currentLanguage, configInfo } = useTranslation();
  const {
    ticketBookingOptions: options,
  } = useAuth();

  const isGeorgia = configInfo?.countryCode === 'GE';

  const stationsMap = useMemo(() => {
    const map = new Map();
    options?.stations?.forEach((station) => {
      map.set(station.value, station?.[`label_${currentLanguage}`] || station.label_ka);
    });
    return map;
  }, [options?.stations, currentLanguage]);

  const [schedules, setSchedules] = useState(null);

  const [form] = Form.useForm();

  const fetchSchedules = async (params) => {
    if (params?.startDate) {
      // eslint-disable-next-line no-param-reassign
      params.startDate = moment(params.startDate).format('YYYY-MM-DD');
    }
    const response = await getSchedules(params);
    response?.list.sort(compareDepartureTime);
    const groupedSchedules = response?.list
      ?.reduce(
        (acc, schedule) => {
          if (acc?.[routeTypes[schedule.routeType?.code] || schedule.routeType?.code]) {
            acc[routeTypes[schedule.routeType?.code] || schedule.routeType?.code].push(schedule);
            return acc;
          }
          return acc;
        },
        isGeorgia ? {
          local_trains: [],
          district_trains: [],
          international_trains: [],
        }
          : {
            international_trains: [],
          },
      );
    setSchedules(groupedSchedules);
    if (allSchedules.current === null) {
      allSchedules.current = groupedSchedules;
    }
  };

  useEffect(() => {
    fetchSchedules({
      startDate: moment().format('YYYY-MM-DD'),
    });
  }, []);

  return (
    <div className="flex flex-col gap-10 relative lg:px-10">
      <div className="flex gap-[35px] sm:items-center flex-col sm:flex-row items-start">
        <h2
          className="font-big-bold text-2xl m-0"
        >
          {trans('train_schedule')}
        </h2>
      </div>
      <div className="flex justify-center">
        <ScheduleForm form={form} onFinish={fetchSchedules} />
      </div>
      <div className="flex flex-col gap-8">
        {
          schedules && Object.keys(schedules)?.map((key) => (
            <React.Fragment
              key={key}
            >
              <h3
                className="font-big-bold text-base"
              >
                {trans(key)}
              </h3>
              <ScheduleList
                schedules={schedules[key]}
                stationsMap={stationsMap}
              />
            </React.Fragment>
          ))
        }
      </div>
    </div>
  );
}

export default Schedule;
